import { TARGET_SEGMENT } from '../../cms/constants';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectTargetSegment = (state) =>
  state?.referral?.targetSegment ?? TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE;

export default selectTargetSegment;
